import React from "react";
import Helmet from "react-helmet";
import { Provider } from "rebass";
import graphql from "graphql";
import styled from "styled-components";

import MixpanelProvider from "react-mixpanel";
import { mixpanel } from "../../gatsby-browser";

import theme from "../utils/theme";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
// import OptIn from "../components/OptIn";
import FacebookSDK from "../components/FacebookSDK/FacebookSDK";
import UserProvider from "../components/providers/UserProvider";
import "./all.scss";

type Props = {
  children: React.Node,
  data: {
    site: {
      siteMetadate: {}
    }
  }
};

const { Fragment } = React;

const TemplateWrapper = ({
  children,
  data: {
    site: { siteMetadata }
  }
}: Props) => (
  <Provider theme={theme}>
    <Helmet title="Pipeline" />

    <MixpanelProvider mixpanel={mixpanel}>
      <UserProvider
        render={user => (
          <Fragment>
            <Navbar siteMetadata={siteMetadata} user={user} />

            <Children>{children()}</Children>

            <Footer siteMetadata={siteMetadata} />

            {/* <OptIn /> */}

            <FacebookSDK />

            <div className="fb-customerchat" page_id="227754084405138" />
          </Fragment>
        )}
      />
    </MixpanelProvider>
  </Provider>
);

export default TemplateWrapper;

// Styled Components
const Children = styled.div`
  position: relative;
  z-index: 1;
`;

export const pageQuery = graphql`
  query indexQuery {
    site {
      siteMetadata {
        appUrl
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx